// ============================================================
// ANSICHTSSACHE-AGENT – Die Zuglasche
// ============================================================
// Ein schmaler, gerillter Griff, an dem eine Zeile verschoben
// wird. Er braucht keinen Platz IN der Zeile: er steht am Rand
// der Flaeche oder ragt ueber ihn hinaus, und erst beim
// Hinzeigen auf die Zeile wird er sichtbar (`group-hover`).
//
// Vorher stand dort das Punktraster (`GripVertical`) — 16 px
// breit, und in den 17 px Rand des Belegblatts passte es nur
// Kante an Kante mit der Positionsnummer. Die Lasche ist 10 px
// breit und kann deshalb ganz in den Rand neben der Karte
// ruecken (Ansage vom 07.10.2026, nach einer Vorlage des
// Nutzers).
//
// Lage und Hoehe gibt der Aufrufer (`className`): die Zeile
// weiss, wo ihre erste Zeile steht.
// ============================================================

import { cn } from "@/lib/utils";

/**
 * Waagerecht: im Belegblatt ragt die Lasche links aus der Karte in
 * den Rand daneben (`--drag-tab-left`, gesetzt in
 * `DocumentSheetBody`); ueberall sonst steht sie im Zeilenrand.
 * Die Zeile braucht `relative`.
 */
export const DRAG_TAB_LEFT = "absolute left-[var(--drag-tab-left,5px)]";
/** Senkrecht auf der Mitte einer einzeiligen Zeile. */
export const DRAG_TAB_MIDDLE = "top-1/2 h-6 -translate-y-1/2";
/** Auf der ersten Zeile einer Zeile mit `py-3`, die mit ihrer Beschreibung waechst. */
export const DRAG_TAB_FIRST_LINE = "top-3 h-6";
/** Ueberschrift mit `pt-6 pb-2`: oben 16 px mehr Luft als unten. */
export const DRAG_TAB_HEADING = "top-[calc(50%+8px)] h-6 -translate-y-1/2";

/** Die Rillen: feine Querstriche im Abstand von 3 px. */
const RILLEN =
  "bg-[repeating-linear-gradient(to_bottom,var(--color-border-strong)_0_1px,transparent_1px_3px)] bg-[length:4px_100%] bg-center bg-no-repeat";

export function DragTab({ className, ...rest }: React.ComponentPropsWithoutRef<"span">) {
  return (
    <span
      aria-hidden
      className={cn(
        "border-border bg-bg-tertiary hover:border-border-strong shadow-e1 w-2.5 cursor-grab rounded-full border",
        "duration-fast opacity-0 transition-opacity group-hover:opacity-100 active:cursor-grabbing",
        RILLEN,
        className,
      )}
      {...rest}
    />
  );
}
